// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-tsx": () => import("/home/travis/build/tabneib/gatsby-router-issue/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

